export { default } from "ember-stereo/helpers/numeric-duration";
